import { IPagination } from '../admin-flow/admin-flow-interfaces'

export interface DataType {
  id: number
  name: string
  language: string
  location: string
  gender: string
  email: string
  roleType: string
  requestType: string
  meetingSlot: string
  createdDateTime: string
  meetingPreferences: string
  phone?: string
  status: {
    id: string
    name: string
  }
  /* eslint-disable @typescript-eslint/no-explicit-any */
  Action: any
}

export interface IPendingConversationActions {
  selectedCard: string
  record: any
  accepted: { [id: number]: boolean }
  showModal: (recordedId: number) => void
  fetchRequestData: (statusId: string) => void
}

export interface IEmptyTableComponent {
  selectedCard: string
}

export interface IAttemptOutreachModal {
  recordId: number
  isModalOpen: boolean
  name: string
  meetingSlot: string
  meetingPreferences: string
  setIsModalOpen: (isOpen: boolean) => void
  toggleAccepted: (recordId: number) => void
  setAttemptedOutreach: (recordId: number) => void
  phone?: string
  email: string
}

export interface IMarkCompletedModal {
  recordId: number
  isModalOpen: boolean
  setIsModalOpen: (isOpen: boolean) => void
}

export interface ISupporterMobileTable {
  data: DataType[]
  setAttemptedOutreach: (id: number) => void
  fetchRequestData: (statusId: string) => void
  pagination: IPagination
  onPageChange: (page: number, pageSize: number) => void
}

export enum SelectedCard {
  PENDING_CONVERSATIONS = 'pending-conversations',
  AWAITING_REFERRALS = 'awaiting-referrals',
  COMPLETED_CONVERSATIONS = 'completed-conversations',
}

export interface IPeerRequestResponseInterface {
  id: string
}

export type DataIndex = keyof DataType
